export interface StatusDisplay {
  label: string;
  suffix?: string;
}

export enum AUDIT_STATUS {
  PENDING = 'PENDING',
  AGENT_CLEARED = 'AGENT_CLEARED',
  AGENT_VIOLATION = 'AGENT_VIOLATION',
  TL_CONFIRMED_CLEARED = 'TL_CONFIRMED_CLEARED',
  TL_CONFIRMED_VIOLATION = 'TL_CONFIRMED_VIOLATION',
  TL_OVERRULED_TO_CLEARED = 'TL_OVERRULED_TO_CLEARED',
  TL_OVERRULED_TO_VIOLATION = 'TL_OVERRULED_TO_VIOLATION',
  TL_DIRECT_CLEARED = 'TL_DIRECT_CLEARED',
  TL_DIRECT_VIOLATION = 'TL_DIRECT_VIOLATION'
}

export const STATUS_DISPLAY_MAP: Record<AUDIT_STATUS, StatusDisplay> = {
  [AUDIT_STATUS.PENDING]: { label: 'Pending' },
  [AUDIT_STATUS.AGENT_CLEARED]: { label: 'Cleared' },
  [AUDIT_STATUS.AGENT_VIOLATION]: { label: 'Violation' },
  [AUDIT_STATUS.TL_CONFIRMED_CLEARED]: { label: 'Cleared', suffix: 'Confirmed' },
  [AUDIT_STATUS.TL_CONFIRMED_VIOLATION]: { label: 'Violation', suffix: 'Confirmed' },
  [AUDIT_STATUS.TL_OVERRULED_TO_CLEARED]: { label: 'Cleared', suffix: 'Updated' },
  [AUDIT_STATUS.TL_OVERRULED_TO_VIOLATION]: { label: 'Violation', suffix: 'Updated' },
  [AUDIT_STATUS.TL_DIRECT_CLEARED]: { label: 'Cleared', suffix: 'Reviewed' },
  [AUDIT_STATUS.TL_DIRECT_VIOLATION]: { label: 'Violation', suffix: 'Reviewed' }
};

export enum AUDIT_TYPE {
  DS = 'DS',
  QC_AGENT = 'QC_AGENT',
  QC_TEAM_LEAD = 'QC_TEAM_LEAD'
}

export const APPROX_CHAR_WIDTH = 8; // approximate character width
export const ITEM_PADDING = 16; // padding for each value item (8px * 2)
export const ITEM_MARGIN = 4; // margin between items
export const SEPARATOR_WIDTH = 5; // width of vertical separator (1px + margins)
export const MORE_BUTTON_WIDTH = 60; // approximate width for "+X more" button
export const DEFAULT_CONTAINER_WIDTH = 400; // default container width
